import { render, staticRenderFns } from "./OrdersProducts.vue?vue&type=template&id=09b34134&scoped=true&"
import script from "./OrdersProducts.vue?vue&type=script&lang=js&"
export * from "./OrdersProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrdersProducts.vue?vue&type=style&index=0&id=09b34134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b34134",
  null
  
)

export default component.exports